"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataOutputAssociation = void 0;
const BaseElement_1 = require("./BaseElement");
/**
 * Contains a BPMN DataOutputAssociation.
 * These associations signify that a FlowNode writes data into a DataObject or DataStore.
 */
class DataOutputAssociation extends BaseElement_1.BaseElement {
}
exports.DataOutputAssociation = DataOutputAssociation;
//# sourceMappingURL=DataOutputAssociation.js.map